(function () {
    var cartQueue = [];
	var clientSubdomain = 'wardoworld';
    var fixedQuantityItems = {
        //'SET-UP': 1
    };
    var activeCartProcess;

    function generateUUID() { // Public Domain/MIT
        var d = new Date().getTime(); //Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16; //random number between 0 and 16
            if (d > 0) { //Use timestamp until depleted
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else { //Use microseconds since page-load if supported
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    function getFixedQuantity(sku) {
        return fixedQuantityItems[sku];
    }

    function setMasterProduct(addJsResponse, data, groupUUID) {
        // Reset properties
        const configurationSKU = addJsResponse.properties['Configuration SKU'];
        const configurationLink = addJsResponse.properties['Configuration Link'];
        delete addJsResponse.properties['Configuration SKU'];
        delete addJsResponse.properties['Configuration Link'];

        const shopifyLocale = Shopify.locale || 'en';

        addJsResponse.properties = Object.assign(addJsResponse.properties, {
            _configuration_sku: configurationSKU,
            _customizer_group_id: groupUUID,
            _preview_image: data.thumbnail, // Dynamic
            _customizer_master: true, // Fixed
            _configuration_link: `https://${configurationLink}&currency=GBP&locale=${shopifyLocale}`,
        });

        // Set master product
        if (!data.hasOwnProperty('variant_ids')) {
            throw new Error('variant not fount');
        }

        const configuredProduct = data.configuredProduct;

        const masterDummy = configuredProduct.articles.find(function (item) {
            return item.models_sku && item.models_sku.includes('cm');
        });

        if (!masterDummy) {
            throw new Error('master not found');
        }

        const searchParams = new URLSearchParams(window.location.search);
        addJsResponse.quantity = searchParams.get('quantity') || 1;

        addJsResponse.id = data.variant_ids[masterDummy.models_sku];

        // Remove the master, so we can add all other items later
        delete data.variant_ids[masterDummy.models_sku];
    }

    function requestPrintReadyFile(data, mediaId) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/apps/configurator',
                type: 'POST',
                data: JSON.stringify({
                    svg_convert: true,
                    configuration: {
                        catalogue_id: data.configuredProduct.catalogue_id,
                        attributes: data.configuredProduct.configuration.attributes
                    },
                    media_id: mediaId,
                    format: 'pdf',
                    dpi: data.dpi,
                    hide_printmarks: true,
                    hide_placeholders: true,
                    cmyk: true
                }),
                contentType: "application/json"
            }).done(function (response) {
                if (!response.status) {
                    return reject();
                }

                resolve('https://'+clientSubdomain+'.expivi.net/print-ready-service?hash='+response.hash);
            });
        });
    }

    function getPrintReadyFile(data) {
        return new Promise(function (resolve) {
            const configuredProduct = data.configuredProduct;
            const designAttribute = configuredProduct.attributes.find(function (attr) {
                return attr.attribute_value &&
                    Number.isInteger(attr.attribute_value.media_id) &&
                    attr.attribute_value.svg_element;
            });

            if (!designAttribute) {
                resolve();
            }

            requestPrintReadyFile(data, designAttribute.attribute_value.media_id).then(function (filePath) {
                resolve(filePath);
            });
        });
    }

    // Note: shopify doesn't allow simultaneous calls to add.js, so we build a queue
    function processQueue() {
        if (activeCartProcess || cartQueue.length === 0) {
            return;
        }

        activeCartProcess = cartQueue.shift();
        $.post('/cart/add.js', activeCartProcess.data, null, 'json').done(function () {
            activeCartProcess.readyCallback();
        }).fail(function () {
            activeCartProcess.failCallback();
        }).always(function () {
            activeCartProcess = null;
            processQueue();
        });
    }

    function addProductToCart(data) {
        return new Promise(function (resolve, reject) {
            cartQueue.push({
                data: data,
                readyCallback: resolve,
                failCallback: reject
            });

            processQueue();
        });
    }

    function addMasterProductToCart(addJsResponse) {
        return addProductToCart(addJsResponse);
    }

    function addSubSequentProductsToCart(data, groupUUID) {
        return new Promise(function (resolve, reject) {
            const configuredProduct = data.configuredProduct;

            if (!configuredProduct || !Array.isArray(configuredProduct.articles)) {
                reject();
            }

            const addPromises = [];

            configuredProduct.articles.forEach(function (model) {
                if (!(model.models_sku in data.variant_ids) || !data.variant_ids[model.models_sku]) {
                    return;
                }

                const searchParams = new URLSearchParams(window.location.search);
                const quantity = searchParams.get('quantity') || 1;
                const fixedQuantity = getFixedQuantity(model.models_sku);

                const addToCart = addProductToCart({
                    "id": data.variant_ids[model.models_sku],
                    "quantity": fixedQuantity ? fixedQuantity : quantity,
                    "properties": {
                        "_customizer_group_id": groupUUID,
                        "_fixed_quantity": fixedQuantity,
                    }
                });

                addPromises.push(addToCart);

                // Remove from list so it doesn't get re-added
                delete data.variant_ids[model.models_sku];
            });

            Promise.all(addPromises).then(function () {
                resolve();
            }, function () {
                reject();
            });
        });
    }

    function enableAddToCart() {
        const $button = $('button.expivi-add-to-cart');

        $button.removeAttr('disabled');
        $button.removeClass('loading');
    }

    function addToCart(resolve, reject, addJsResponse, data) {
        const groupUUID = generateUUID();

        try {
            setMasterProduct(addJsResponse, data, groupUUID);
        } catch (err) {
            enableAddToCart();
            return;
        }

        getPrintReadyFile(data)
            .then(function (printReadyFilePath) {
                if (printReadyFilePath) {
                    addJsResponse.properties['_print_ready_file'] = printReadyFilePath;
                }

                Promise.all([
                    addMasterProductToCart(addJsResponse),
                    addSubSequentProductsToCart(data, groupUUID)
                ]).finally(function () {
                    enableAddToCart();
                    window.location.href = '/cart';
                });
            });
    }

    window.expiviCartAfterStore = function (resolve, reject, addJsResponse, data) {
        data.dpi = data.dpi || 300;
        addToCart(resolve, reject, addJsResponse, data);
    };
})();